(() => {
  'use strict';

  // ----- Reveal -----
  const revealObs = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        revealObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  document.querySelectorAll('.reveal').forEach(el => revealObs.observe(el));

  // ----- Topbar -----
  const topbar = document.getElementById('topbar');
  const fill   = document.getElementById('progress-fill');
  const tag    = document.getElementById('act-tag');
  const logo   = document.getElementById('topbar-logo');
  const acts = {1:'I · El recuento', 2:'II · La factura', 3:'III · Hacer sitio', 4:'IV · Volver'};
  const sects = [...document.querySelectorAll('section[data-act]')];
  function onScroll() {
    const docH = document.documentElement.scrollHeight - window.innerHeight;
    const pct = Math.min(100, Math.max(0, (window.scrollY/docH)*100));
    if (fill) fill.style.width = pct + '%';
    const mid = window.scrollY + window.innerHeight*0.4;
    let cur = '1', dark = false;
    for (const s of sects) {
      if (mid >= s.offsetTop && mid < s.offsetTop+s.offsetHeight) {
        cur = s.dataset.act;
        if (s.classList.contains('inventario') || s.classList.contains('odometro') || s.classList.contains('espejo') || s.classList.contains('puertas')) dark = true;
        break;
      }
    }
    if (tag) tag.textContent = acts[cur];
    if (topbar) topbar.classList.toggle('dark', dark);
  }
  window.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', onScroll);
  onScroll();

  // ----- Shelf bottles appearing one by one -----
  const shelf = document.getElementById('shelf');
  const shelfNum = document.getElementById('shelf-num');
  if (shelf) {
    const bottles = [...shelf.querySelectorAll('.shelf-bottle')];
    let appeared = 0;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          bottles.forEach((b, i) => {
            setTimeout(() => {
              b.classList.add('in');
              appeared++;
              if (shelfNum) shelfNum.textContent = appeared;
            }, i * 220);
          });
          obs.unobserve(shelf);
        }
      });
    }, { threshold: 0.3 });
    obs.observe(shelf);
  }

  // ----- Odometer counters -----
  const odoCells = [...document.querySelectorAll('.odo-num')];
  odoCells.forEach(cell => {
    const target = parseInt(cell.dataset.target, 10);
    const valEl  = cell.querySelector('.odo-val');
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting && valEl) {
          const dur = 1800;
          const start = performance.now();
          function tick(now) {
            const t = Math.min(1, (now - start)/dur);
            const eased = 1 - Math.pow(1 - t, 3);
            const val = Math.floor(eased * target);
            valEl.textContent = val.toLocaleString('es-ES');
            if (t < 1) requestAnimationFrame(tick);
            else valEl.textContent = target.toLocaleString('es-ES');
          }
          requestAnimationFrame(tick);
          obs.unobserve(cell);
        }
      });
    }, { threshold: 0.5 });
    obs.observe(cell);
  });

  // ----- Mirror cracks + words -----
  const mirror = document.getElementById('mirror');
  const mirrorWords = document.getElementById('mirror-words');
  if (mirror) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          mirror.classList.add('cracked');
          setTimeout(() => mirrorWords && mirrorWords.classList.add('in'), 1400);
          obs.unobserve(mirror);
        }
      });
    }, { threshold: 0.4 });
    obs.observe(mirror);
  }

  // ----- Trash interactive -----
  const trashBoard = document.getElementById('trash-board');
  const trashCount = document.getElementById('trash-count');
  const trashCelebrate = document.getElementById('trash-celebrate');
  if (trashBoard) {
    let count = 0;
    trashBoard.addEventListener('click', (e) => {
      const b = e.target.closest('.trash-bottle');
      if (!b || b.classList.contains('gone')) return;
      b.classList.add('gone');
      count++;
      if (trashCount) trashCount.textContent = count;
      if (count >= 8 && trashCelebrate) {
        setTimeout(() => trashCelebrate.classList.add('show'), 600);
      }
    });
  }

  // ----- Letter typing -----
  const cartaText = document.getElementById('carta-text');
  const cartaSign = document.getElementById('carta-sign');
  const letter = [
    "He visto a cientos de mujeres llegar a este punto.",
    "Cansadas. Con once botes. Sin culpa — porque la culpa no es tuya.",
    "Te enseñaron a comprar, no a cuidarte.",
    "El camino que proponemos no es rápido. Pero es <strong>tuyo</strong>. Y se queda.",
    "Si decides cruzar, voy contigo. Si no, también está bien."
  ];
  if (cartaText) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          obs.unobserve(cartaText);
          typeLetter();
        }
      });
    }, { threshold: 0.3 });
    obs.observe(cartaText);

    function typeLetter() {
      let pIdx = 0;
      function nextP() {
        if (pIdx >= letter.length) {
          // remove cursor, show signature
          const last = cartaText.lastElementChild;
          if (last) last.classList.remove('carta-typed');
          if (cartaSign) cartaSign.classList.add('in');
          return;
        }
        const p = document.createElement('p');
        p.className = 'carta-typed';
        cartaText.appendChild(p);
        // remove cursor on previous
        const prev = p.previousElementSibling;
        if (prev) prev.classList.remove('carta-typed');
        const text = letter[pIdx];
        let i = 0;
        function tick() {
          if (i > text.length) {
            pIdx++;
            setTimeout(nextP, 400);
            return;
          }
          p.innerHTML = text.slice(0, i);
          i++;
          // pause on tags
          const ch = text[i-1];
          const delay = ch === '.' || ch === ',' ? 60 : (Math.random()*22 + 14);
          setTimeout(tick, delay);
        }
        tick();
      }
      nextP();
    }
  }

})();
